function scrollbarWidth() {
	let div = document.createElement('div');

	div.style.overflowY = 'scroll';
	div.style.width = '50px';
	div.style.height = '50px';
	div.style.visibility = 'hidden';
	document.body.appendChild(div);

	let scrollWidth = div.offsetWidth - div.clientWidth;

	document.body.removeChild(div);

	return scrollWidth;
}

function addScrollbarOffset() {
	if ($(document).height() > $(window).height()) {
		$(document.body).css({
			right: `${scrollbarWidth()}px`,
		});
		$('.filter').css({
			right: `${scrollbarWidth()}px`,
		});
	}
}

function removeScrollbarOffset() {
	$(document.body).css({
		right: 0,
	});
	$('.filter').css({
		right: 0,
	});
}

export {
	addScrollbarOffset,
	removeScrollbarOffset,
};
